import RouteModel from "../models/route.model";

export const ROUTES_CONST = {
	LOGIN: <RouteModel>{
		name: "Login",
		routerLink: "/auth/login",
		path: "auth/login",
	},
	FORBIDDEN: <RouteModel>{
		name: "Forbidden",
		routerLink: "/security/403",
		path: "security/403",
	},
	HOME: <RouteModel>{
		name: "Inicio",
		routerLink: "/main/dashboard",
		path: "main/dashboard",
	},
	CONFIRM_PSWD: <RouteModel>{
		name: "Confirmar Clave",
		routerLink: "/security/confirmar-clave",
		path: "security/confirmar-clave",
	},
	PERFIL: <RouteModel>{
		name: "Perfil",
		routerLink: "/main/security/perfil",
		path: "main/security/perfil",
	},
	HELP: <RouteModel>{
		name: "Ayuda",
		routerLink: "/main/dashboard/ayuda",
		path: "main/dashboard/ayuda",
	},
	STUDENTS: <RouteModel>{
		name: "Estudiantes",
		routerLink: "/estudiantes",
		path: "estudiantes",
	},
	STUDENTS_NEW: <RouteModel>{
		name: "Nuevo Estudiante",
		routerLink: "/estudiantes/nuevo",
		path: "estudiantes/nuevo",
	},
	STUDENTS_EDIT: <RouteModel>{
		name: "Editar Estudiante",
		routerLink: "/estudiantes/editar/",
		path: "estudiantes/editar/",
	},
	AUDITORIA: <RouteModel>{
		name: "Auditoria",
		routerLink: "/demo/auditoria",
		path: "demo/auditoria",
	},
	PROGRAMA: <RouteModel>{
		name: "Programas",
		routerLink: "/pre-academico/programas",
		path: "pre-academico/programas",
	},
	PROGRAMA_CONFIG: <RouteModel>{
		name: "Configuración de Programa",
		routerLink: "/main/configuraciones/pre-academico/programas/configuracion/",
		path: "main/pre-academico/programas/configuracion/",
	},
	PROGRAMA_NUEVO: <RouteModel>{
		name: "Nuevo Programa",
		routerLink: "/main/configuraciones/pre-academico/programas/nuevo-programa/",
		path: "main/pre-academico/programas/nuevo-programa/",
	},
	DUPLICAR_PROGRAMA: <RouteModel>{
		name: "Duplicar Programa",
		routerLink: "/main/configuraciones/pre-academico/programas/duplicar-programa/",
		path: "main/pre-academico/programas/duplicar-programa/",
	},
	DETALLE_PROGRAMA: <RouteModel>{
		name: "Ver Detalle Programa",
		routerLink: "/main/configuraciones/pre-academico/programas/detalle-programa/",
		path: "main/pre-academico/programas/detalle-programa/",
	},
	SEDE: <RouteModel>{
		name: "Sedes",
		routerLink: "/main/configuraciones/configuracion-basica/sedes",
		path: "main/configuracion-basica/sedes",
	},
	RESOLUCION: <RouteModel>{
		name: "Gestión Resoluciones",
		routerLink: "/main/configuraciones/configuracion-basica/resoluciones",
		path: "main/configuracion-basica/resoluciones",
	},
	RESOLUCION_PROGRAMA: <RouteModel>{
		name: "Resolución - Programas",
		routerLink: "/main/configuraciones/configuracion-basica/resoluciones/programas",
		path: "main/configuracion-basica/resoluciones/programas",
	},
	TIPOSCLASE: <RouteModel>{
		name: "Tipos de clase",
		routerLink: "/pre-academico/tiposclase",
		path: "pre-academico/tiposclase",
	},
	SALONES: <RouteModel>{
		name: "Gestion de Salones",
		routerLink: "/main/configuraciones/pre-academico/salones",
		path: "main/pre-academico/salones",
	},
	MODALIDADES: <RouteModel>{
		name: "Modalidades",
		routerLink: "/pre-academico/modalidades",
		path: "pre-academico/modalidades",
	},
	JORNADAS: <RouteModel>{
		name: "Jornadas",
		routerLink: "/configuracion-basica/jornadas",
		path: "configuracion-basica/jornadas",
	},
	MATERIAL: <RouteModel>{
		name: "Materiales",
		routerLink: "/configuracion-basica/materiales",
		path: "configuracion-basica/materiales",
	},
	ETAPA: <RouteModel>{
		name: "Etapas",
		routerLink: "/pre-academico/etapas",
		path: "pre-academico/etapas",
	},
	UNIDAD: <RouteModel>{
		name: "Unidades",
		routerLink: "/pre-academico/unidades",
		path: "pre-academico/unidades",
	},
	CLASE: <RouteModel>{
		name: "Clases",
		routerLink: "/pre-academico/clases",
		path: "pre-academico/clases",
	},
	SERVICIOSADICIONALES: <RouteModel>{
		name: "Servicios adicionales",
		routerLink: "/configuracion-basica/serviciosadicionales",
		path: "configuracion-basica/serviciosadicionales",
	},

	PLANES_ESPECIALES: <RouteModel>{
		name: "Planes Especiales Online",
		routerLink: "/configuracion-basica/planes-especiales",
		path: "configuracion-basica/planes-especiales",
	},
	CONTRATOS: <RouteModel>{
		name: "Matricula",
		routerLink: "/main/procesos-academicos/contratos",
		path: "main/procesos-academicos/contratos",
	},
	TIPO_PERSONA: <RouteModel>{
		name: "Usuarios",
		routerLink: "/usuarios/tipo-persona",
		path: "usuarios/tipo-persona",
	},
	HORARIO_FIJO: <RouteModel>{
		name: "Gestión de Horarios Fijos",
		routerLink: "/horarios/fijo",
		path: "horarios/fijo",
	},

	TIPO_CONTRATACION: <RouteModel>{
		name: "Tipos de Contrataciones",
		routerLink: "/configuracion-basica/tipos-contratacion",
		path: "configuracion-basica/tipos-contratacion",
	},

	DOCENTES: <RouteModel>{
		name: "Docentes",
		routerLink: "/main/usuarios/tipo-persona/docente",
		path: "main/usuarios/tipo-persona/docente",
	},

	HORARIO_DOCENTES: <RouteModel>{
		name: "Horario Docentes",
		routerLink: "/main/usuarios/tipo-persona/docente",
		path: "main/usuarios/tipo-persona/docente",
	},

	HORARIO_ALTERNO_DOCENTES: <RouteModel>{
		name: "Horario Alterno Docentes",
		routerLink: "/main/usuarios/tipo-persona/docente",
		path: "main/usuarios/tipo-persona/docente",
	},

	HORARIOS_SEDE: <RouteModel>{
		name: "Horarios Sede",
		routerLink: "/main/configuraciones/configuracion-basica/sedes/horarios-sede/",
		path: "main/configuracion-basica/sedes/horarios-sede/",
	},
	CONFIGURACION_HORARIO_BLOQUEADO: <RouteModel>{
		name: "Configuración de Horario Bloqueado",
		routerLink: "/configuracion-basica/configuracion-horario-bloqueado",
		path: "configuracion-basica/configuracion-horario-bloqueado",
	},
	PARAMETROS_GENERALES: <RouteModel>{
		name: "Parámetros Generales",
		routerLink: "/configuracion-basica/parametros-generales",
		path: "configuracion-basica/parametros-generales",
	},
	GESTION_CONCEPTO_DE_PAGOS: <RouteModel>{
		name: "Gestión Concepto De Pagos",
		routerLink: "/main/configuraciones/configuracion-basica/gestion-concepto-pago",
		path: "main/configuracion-basica/gestion-concepto-pago",
	},
	CARGO_ADMINISTRATIVO: <RouteModel>{
		name: "Cargos Administrativos",
		routerLink: "/configuracion-basica/cargo-administrativo",
		path: "configuracion-basica/cargo-administrativo",
	},
	BARRIOS: <RouteModel>{
		name: "Barrios",
		routerLink: "/configuracion-basica/barrios",
		path: "configuracion-basica/barrios",
	},
	ESTADO_SOLICITUD_ACADEMICA: <RouteModel>{
		name: "Estado Solicitud Académica",
		routerLink: "/solicitudes/estado-solicitud",
		path: "solicitudes/estado-solicitud",
	},
	SOLICITUDES_ACADEMICAS: <RouteModel>{
		name: "Solicitudes Académicas",
		routerLink: "/solicitudes/tipo-solicitudes",
		path: "solicitudes/tipo-solicitudes",
	},
	GESTION_TIPO_SOLICITUD: <RouteModel>{
		name: "Gestión Tipo Solicitud",
		routerLink: "/solicitudes/tipo-solicitud",
		path: "/solicitudes/tipo-solicitud",
	},
	GESTION_TIPO_SOLICITUD_CONFIG: <RouteModel>{
		name: "Configuración de Tipo Solicitud",
		routerLink: "/main/solicitudes/gestion-tipo-solicitud/configuracion/",
		path: "main/solicitudes/gestion-tipo-solicitud/configuracion/",
	},
	HORARIOS_SALON: <RouteModel>{
		name: "Horarios Salon",
		routerLink: "/main/configuraciones/pre-academico/salones/horarios-salon/",
		path: "main/pre-academico/salones/horarios-salon/",
	},
	PLAN_PAGO: <RouteModel>{
		name: "Gestión Plan Pago",
		routerLink: "/main/configuraciones/configuracion-basica/plan-pago",
		path: "main/configuracion-basica/plan-pago",
	},
	GESTION_SOLICITUDES: <RouteModel>{
		name: "Gestión de Solicitudes Académicas",
		routerLink: "/main/solicitudes/gestion-solicitudes",
		path: "main/solicitudes/gestion-solicitudes",
	},
	LUGAR: <RouteModel>{
		name: "Lugares",
		routerLink: "/pre-academico/lugares",
		path: "pre-academico/lugares",
	},
	HORARIOS_DOCENTE: <RouteModel>{
		name: "Horarios Docente",
		routerLink: "/main/usuarios/tipo-persona/docente/horario/",
		path: "main/usuarios/tipo-persona/docente/horario/",
	},
	ACTIVACION_LIBRO: <RouteModel>{
		name: "Activación de Libro",
		routerLink: "/main/solicitudes/activacion-libro",
		path: "main/solicitudes/activacion-libro",
	},
	APROBACIONES_ACADEMICAS: <RouteModel>{
		name: "Aprobaciones Académicas",
		routerLink: "/main/procesos-academicos/aprobaciones/",
		path: "main/procesos-academicos/aprobaciones/",
	},
	VISUALIZACION_HORARIO: <RouteModel>{
		name: "Visualización",
		routerLink: "/main/horarios/fijo/visualizacion",
		path: "main/horarios/fijo/visualizacion",
	},
	HORARIOS_MANUAL: <RouteModel>{
		name: "Creación Horario Manual",
		routerLink: "/main/horarios/fijo/manual",
		path: "main/horarios/fijo/manual",
	},
	HORARIOS_PREDICCION: <RouteModel>{
		name: "Creación Horario por Prediccion",
		routerLink: "/main/horarios/predccion/",
		path: "main/procesos-academicos/horarios/prediccion",
	},
	ASIGNACION_CLASE_MANUAL: <RouteModel>{
		name: "Asignar Clase Manual",
		routerLink: "/main/horarios/asignacion-clase-manual/:id",
		path: "main/horarios/asignacion-clase-manual/:id",
	},
	ASISTENCIA_CONSULTAR_HORARIOS: <RouteModel>{
		name: "Asistencia Docentes",
		routerLink: "/main/procesos-academicos/asistencia",
		path: "/main/procesos-academicos/asistencia",
	},
	ASISTENCIA_CONSULTAR_HORARIOS_PERFECCIONAMIENTO: <RouteModel>{
		name: "Asistencias Perfeccionamiento",
		routerLink: "/main/procesos-academicos/asistencia-perfeccionamiento",
		path: "/main/procesos-academicos/asistencia-perfeccionamiento",
	},
	CLASES_GRABADAS: <RouteModel>{
		name: "Clases Grabadas",
		routerLink: "/main/clase-grabadas/",
		path: "/main/clases-grabadas",
	},
	CALENDARIO_ADMISIONES: <RouteModel>{
		name: "Gestión Calendario Admisiones",
		routerLink: "/main/calendario-admisiones/",
		path: "/main/calendario-admisiones",
	},
	SHOW_ASISTENCIA: <RouteModel>{
		name: "Asistencias",
		routerLink: "/main/procesos-academicos/asistencia/ver-asistencias",
		path: "/main/procesos-academicos/asistencia/ver-asistencias",
	},
	DETALLE_HORARIO: <RouteModel>{
		name: "Asistencias",
		routerLink: "/main/procesos-academicos/asistencia/detalle-horario",
		path: "/main/procesos-academicos/asistencia/detalle-horario",
	},
	SHOW_ASISTENCIA_PERFECCIONAMIENTO: <RouteModel>{
		name: "Asistencias Perfeccionamiento",
		routerLink:
			"/main/procesos-academicos/asistencia-perfeccionamiento/ver-asistencias",
		path: "/main/procesos-academicos/asistencia-perfeccionamiento/ver-asistencias",
	},
	CLASES_REPASO: <RouteModel>{
		name: "Clases de Repaso",
		routerLink: "/main/procesos-academicos/asistencia/clases-repaso",
		path: "/main/procesos-academicos/asistencia/clases-repaso",
	},
	CLASES_PROGRAMADAS: <RouteModel>{
		name: "Clases Programadas",
		routerLink: "/main/usuarios/tipo-persona/estudiante/clases-programadas",
		path: "/main/usuarios/tipo-persona/estudiante/clases-programadas",
	},
	CLASES_PROGRAMADAS_EGRESADOS: <RouteModel>{
		name: "Clases Programadas - Egresados",
		routerLink:
			"/main/usuarios/tipo-persona/egresado/clases-programadas-egresados",
		path: "/main/usuarios/tipo-persona/egresado/clases-programadas-egresados",
	},
	RECIBO_CAJA_PERSONA: <RouteModel>{
		name: "Recibo Caja - Persona - Crear",
		routerLink: "/main/usuarios/tipo-persona/aspirante/recibo-caja",
		path: "/main/usuarios/tipo-persona/aspirante/recibo-caja",
	},
	VALIDACION_FORMA_PAGO: <RouteModel>{
		name: "Forma Pago",
		routerLink:
			"/main/usuarios/tipo-persona/aspirante/validacion-forma-pago",
		path: "/main/usuarios/tipo-persona/aspirante/validacion-forma-pago",
	},
	ASISTENCIA_REPORTES: <RouteModel>{
		name: "Reporte de Asistencias",
		routerLink: "/main/procesos-academicos/asistencia/reportes",
		path: "/main/procesos-academicos/asistencia/reportes",
	},
	ESTUDIANTE_DASHBOARD: <RouteModel>{
		name: "Dashboard del Estudiante",
		routerLink: "/main/usuarios/tipo-persona/estudiante/summary",
		path: "/main/usuarios/tipo-persona/estudiante/summary",
	},
	EGRESADO_DASHBOARD: <RouteModel>{
		name: "Dashboard del egresado",
		routerLink: "/main/usuarios/tipo-persona/egresado/summary",
		path: "/main/usuarios/tipo-persona/egresado/summary",
	},
	ESTUDIANTE_EDITAR: <RouteModel>{
		name: "Actualizar Estudiante",
		routerLink: "/main/usuarios/tipo-persona/estudiante/edicion",
		path: "/main/usuarios/tipo-persona/estudiante/edicion",
	},
	ESTUDIANTE_CLASES_TEST_FEEDBACK: <RouteModel>{
		name: "Ver Feedback",
		routerLink:
			"/main/usuarios/tipo-persona/estudiante/ejecucion-test/feedback",
		path: "/main/usuarios/tipo-persona/estudiante/ejecucion-test/feedback",
	},
	ESTUDIANTE_ACTIVAR_SLANG: <RouteModel>{
		name: "Estudiante Activar LMS",
		routerLink: "/main/usuarios/tipo-persona/estudiante/slang",
		path: "/main/usuarios/tipo-persona/estudiante/slang",
	},
	ESTUDIANTE_DETALLE: <RouteModel>{
		name: "Detalle Estudiante",
		routerLink: "/main/usuarios/tipo-persona/estudiante/detalle",
		path: "/main/usuarios/tipo-persona/estudiante/detalle",
	},

	ESTUDIANTE_DETALLE_CONTRATO: <RouteModel>{
		name: "Detalle contrato estudiante",
		routerLink: "/main/usuarios/tipo-persona/estudiante/detalle/contrato",
		path: "/main/usuarios/tipo-persona/estudiante/detalle/contrato",
	},
	ESTUDIANTE_DETALLE_ASISTENCIAS: <RouteModel>{
		name: "Detalle Asistencia",
		routerLink: "/main/usuarios/tipo-persona/estudiante/asistencia",
		path: "/main/usuarios/tipo-persona/estudiante/asistencia",
	},
	PROGRAMAR_CLASE: <RouteModel>{
		name: "Programar Clase",
		routerLink: "/main/usuarios/tipo-persona/estudiante/programar-clase/",
		path: "/main/usuarios/tipo-persona/estudiante/programar-clase/",
	},
	ACUDIENTE_EDITAR: <RouteModel>{
		name: "Actualizar Acudiente",
		routerLink: "/main/usuarios/tipo-persona/acudiente/editar",
		path: "/main/usuarios/tipo-persona/acudiente/editar",
	},
	ACUDIENTE_DETALLE: <RouteModel>{
		name: "Detalle Acudiente",
		routerLink: "/main/usuarios/tipo-persona/acudiente/detalles",
		path: "/main/usuarios/tipo-persona/acudiente/detalles",
	},
	REPORTESHOME: <RouteModel>{
		name: "Reportes",
		routerLink: "/main/reportes",
		path: "main/reportes",
	},
	CONFIG_CAMBIO_PROGRAMA: <RouteModel>{
		name: "Configuración Cambio de Programa",
		routerLink: "/configuracion-basica/config-cambio-programa",
		path: "configuracion-basica/config-cambio-programa",
	},
	PLACEMENT_TEST_SCORE: <RouteModel>{
		name: "Placement Test Score",
		routerLink: "/main/configuraciones/configuracion-basica/placement-test-score",
		path: "main/configuracion-basica/placement-test-score",
	},
	CALENDARIO_PERFECCIONAMIENTO: <RouteModel>{
		name: "Gestión Calendario Perfeccionamiento",
		routerLink: "/main/configuraciones/configuracion-basica/calendario-perfeccionamiento/",
		path: "/main/configuraciones/configuracion-basica/calendario-perfeccionamiento",
	},
	PERFECCIONAMIENTO: <RouteModel>{
		name: "Perfeccionamiento",
		routerLink: "/main/procesos-academicos/perfeccionamiento",
		path: "/main/procesos-academicos/perfeccionamiento",
	},
	PERFECCIONAMIENTO_EVALUAR: <RouteModel>{
		name: "Evaluar perfeccionamiento",
		routerLink: "/main/procesos-academicos/perfeccionamiento/evaluar",
		path: "/main/procesos-academicos/perfeccionamiento/evaluar",
	},
	PERFECCIONAMIENTO_CREAR: <RouteModel>{
		name: "Agregar perfeccionamiento",
		routerLink: "/main/procesos-academicos/perfeccionamiento/crear",
		path: "/main/procesos-academicos/perfeccionamiento/crear",
	},
	HORARIOSSOLICITADOS_LIST: <RouteModel>{
		name: "Horarios Solicitados",
		routerLink: "/main/dashboard/estudiante/:id/horariosSolicitados",
		path: "/main/dashboard/estudiante/:id/horariosSolicitados",
	},
	CONGELAMIENTO_LIST: <RouteModel>{
		name: "Solicitud Congelamiento",
		routerLink: "/main/solicitudes/tipo-solicitud/solicitud-congelamiento",
		path: "main/solicitudes/tipo-solicitud/solicitud-congelamiento",
	},
	CONGELAMIENTO_NUEVO: <RouteModel>{
		name: "Nuevo Congelamiento",
		routerLink:
			"/main/solicitudes/tipo-solicitud/solicitud-congelamiento/nuevo",
		path: "main/solicitudes/tipo-solicitud/solicitud-congelamiento/nuevo",
	},
	EXTENSION_LIST: <RouteModel>{
		name: "Solicitud Extension Garantia",
		routerLink: "/main/solicitudes/tipo-solicitud/solicitud-extension",
		path: "main/solicitudes/tipo-solicitud/solicitud-extension",
	},
	EXTENSION_NUEVO: <RouteModel>{
		name: "Nueva Extension Garantia",
		routerLink:
			"/main/solicitudes/tipo-solicitud/solicitud-extension/nuevo",
		path: "main/solicitudes/tipo-solicitud/solicitud-extension/nuevo",
	},
	CONFIGURACION_EMAIL: <RouteModel>{
		name: "Configuración de Correos",
		routerLink: "/main/configuraciones/configuracion-basica/gestion-email",
		path: "main/configuracion-basica/gestion-email",
	},
	PARAMS_EMAIL: <RouteModel>{
		name: "Parámetros de Correo",
		routerLink: "/main/configuraciones/configuracion-basica/params-email",
		path: "main/configuracion-basica/params-email",
	},
	ACTUALIZACION_DATOS_LIST: <RouteModel>{
		name: "Solicitud Congelamiento",
		routerLink:
			"/main/solicitudes/tipo-solicitud/solicitud-actualizacion-datos",
		path: "main/solicitudes/tipo-solicitud/solicitud-actualizacion-datos",
	},
	ACTUALIZACION_DATOS_NUEVO: <RouteModel>{
		name: "Nuevo Congelamiento",
		routerLink:
			"/main/solicitudes/tipo-solicitud/solicitud-actualizacion-datos/nuevo",
		path: "main/solicitudes/tipo-solicitud/solicitud-actualizacion-datos/nuevo",
	},
	PERFECCIONAMIENTO_DETALLE: <RouteModel>{
		name: "Detalle perfeccionamiento",
		routerLink: "/main/procesos-academicos/perfeccionamiento/detalle",
		path: "/main/procesos-academicos/perfeccionamiento/detalle",
	},
	PERFECCIONAMIENTO_RECHAZAR: <RouteModel>{
		name: "Rechazar perfeccionamiento",
		routerLink: "/main/procesos-academicos/perfeccionamiento/rechazar",
		path: "/main/procesos-academicos/perfeccionamiento/rechazar",
	},
	GESTION_SORTEO: <RouteModel>{
		name: "Gestión de Sorteos",
		routerLink: "/main/configuraciones/configuracion-admin/gestion-sorteos",
		path: "/main/configuraciones/configuracion-admin/gestion-sorteos",
	},
	SOLICITUD_CAMBIO_MODALIDAD: <RouteModel>{
		name: "Gestión de Sorteos",
		routerLink: "/main/solicitudes/tipo-solicitud/cambio-modalidad",
		path: "/main/solicitudes/tipo-solicitud/cambio-modalidad",
	},
	SOLICITUD_CAMBIO_MODALIDAD_NUEVO: <RouteModel>{
		name: "Gestión de Sorteos",
		routerLink: "/main/solicitudes/tipo-solicitud/cambio-modalidad/nuevo",
		path: "/main/solicitudes/tipo-solicitud/cambio-modalidad/nuevo",
	},
	SOLICITUD_REINTEGRO: <RouteModel>{
		name: "Solicitud de Reintegro",
		routerLink: "/main/solicitudes/tipo-solicitud/solicitud-reintegro",
		path: "main/solicitudes/tipo-solicitud/solicitud-reintegro",
	},
	SOLICITUD_REINTEGRO_ADD: <RouteModel>{
		name: "Nueva Solicitud de Reintegro",
		routerLink: "/main/solicitudes/reintegro/solicitud-reintegro-add",
		path: "main/solicitudes/reintegro/solicitud-reintegro-add",
	},
	REPORTE_DIARIO_SALUD: <RouteModel>{
		name: "Reporte Diario Salud",
		routerLink: "/main/reporte-diario-salud",
		path: "/main/reporte-diario-salud",
	},
	CONCEPTO_PAGO_CUENTA: <RouteModel>{
		name: "Concepto de Pago Cuenta",
		routerLink:
			"/main/configuraciones/configuracion-admin/gestion-concepto-pago-cuenta/cuenta/",
		path: "/main/configuraciones/configuracion-admin/gestion-concepto-pago-cuenta/cuenta/",
	},
	PERSONA_DOCUMENTO_ADJUNTO: <RouteModel>{
		name: "Persona Documento Adjunto",
		routerLink: "/main/procesos-administrativos/persona-documento-adjunto",
		path: "/main/procesos-administrativos/persona-documento-adjunto",
	},
	MATRICULA_ESPECIAL: <RouteModel>{
		name: "Matricula Especial",
		routerLink: "/main/configuraciones/configuracion-admin/matricula-especial",
		path: "/main/configuraciones/configuracion-admin/matricula-especial",
	},
	SOLICITUD_CAMBIO_CIUDAD_SEDE: <RouteModel>{
		name: "Solicitud de Cambio Ciudad Sede",
		routerLink:
			"/main/solicitudes/tipo-solicitud/solicitud-cambio-ciudad-sede",
		path: "main/solicitudes/tipo-solicitud/solicitud-cambio",
	},
	SOLICITUD_CAMBIO_CIUDAD_SEDE_ADD: <RouteModel>{
		name: "Solicitud de Cambio Ciudad Sede",
		routerLink:
			"/main/solicitudes/tipo-solicitud/solicitud-cambio-ciudad-sede/nuevo",
		path: "main/solicitudes/tipo-solicitud/solicitud-ciudad-sede/nuevo",
	},
	VER_CLASE_GRABADA: <RouteModel>{
		name: "Ver Clase Grabada",
		routerLink: "/main/configuraciones/pre-academico/ver-clase-grabada/ver",
		path: "/main/configuraciones/pre-academico/ver-clase-grabada/ver",
	},
	GESTION_CLASES_GRABADAS: <RouteModel>{
		name: "Gestión de Clases Grabadas",
		routerLink: "/main/configuraciones/pre-academico/clases-grabadas",
		path: "/main/configuraciones/pre-academico/clases-grabadas",
	},
	CLASE_ZOOM: <RouteModel>{
		name: "Reporte de Asistencias",
		routerLink: "/main/procesos-academicos/asistencia/clase-zoom",
		path: "/main/procesos-academicos/asistencia/clase-zoom",
	},
	DASHBOARD_ZOOM: <RouteModel>{
		name: "Inicio",
		routerLink: "/main/dashboard-zoom",
		path: "main/dashboard-zoom",
	},
	GESTION_PASOS: <RouteModel>{
		name: "Gestión de Pasos",
		routerLink: "/main/configuraciones/configuracion-matricula-linea/gestion-pasos",
		path: "/main/configuraciones/configuracion-matricula-linea/gestion-pasos",
	},
	GESTION_PROCESOS: <RouteModel>{
		name: "Gestión de Procesos",
		routerLink: "/main/configuraciones/configuracion-matricula-linea/gestion-procesos",
		path: "/main/configuraciones/configuracion-matricula-linea/gestion-procesos",
	},
	GESTION_PRODUCTOS: <RouteModel>{
		name: "Gestión de productos",
		routerLink: "/main/configuraciones/configuracion-matricula-linea/gestion-productos",
		path: "/main/configuraciones/configuracion-matricula-linea/gestion-productos",
	},
	GESTION_TIPO_DESCUENTO: <RouteModel>{
		name: "Gestión de Tipo de Descuento",
		routerLink:
			"/main/configuraciones/configuracion-matricula-linea/gestion-tipo-descuento",
		path: "/main/configuraciones/configuracion-matricula-linea/gestion-tipo-descuento",
	},
	GESTION_CONFIGURACION_DOCUMENTO_TIPO_DESCUENTO: <RouteModel>{
		name: "Gestion configuracion de Documento Tipo de Descuento",
		routerLink:
			"/main/configuraciones/configuracion-matricula-linea/gestion-documento-tipo-descuento/configuracion-documento-tipo-descuento",
		path: "/main/configuraciones/configuracion-matricula-linea/gestion-documento-tipo-descuento/configuracion-documento-tipo-descuento",
	},
	GESTION_OPORTUNIDAD: <RouteModel>{
		name: "Gestión de Oportunidad",
		routerLink: "/main/configuraciones/configuracion-matricula-linea/gestion-oportunidad",
		path: "/main/configuraciones/configuracion-matricula-linea/gestion-oportunidad",
	},
	GESTION_RECARGOS_ADICIONALES: <RouteModel>{
		name: "Gestión de Recargos Adicionales",
		routerLink:
			"/main/configuraciones/configuracion-matricula-linea/gestion-recargos-adicionales",
		path: "/main/configuraciones/configuracion-matricula-linea/gestion-recargos-adicionales",
	},
	PRODUCTOS_RECARGOS_ADICIONALES: <RouteModel>{
		name: "Gestión de Productos Recargos Adicionales",
		routerLink:
			"/main/configuraciones/configuracion-matricula-linea/gestion-productos/producto-recargo-adicional",
		path: "/main/configuraciones/configuracion-matricula-linea/gestion-productos/producto-recargo-adicional",
	},
	GESTION_SISTEMAS_PROCESO: <RouteModel>{
		name: 'Gestion Sistemas Proceso',
		routerLink: 'configuracion-basica/gestion-sistemas-proceso',
		path: 'configuracion-basica/gestion-sistemas-proceso'
	},
	GESTION_CLASE_TEST: <RouteModel>{
		name: 'Gestion Clase Test',
		routerLink: 'configuracion-academica/gestion-clase-test',
		path: 'configuracion-academica/gestion-clase-test'
	},
	GESTION_LABS_CONFIGURACION: <RouteModel>{
		name: 'Gestion Labs Configuracion',
		routerLink: 'configuracion-academica/gestion-labs-configuracion',
		path: 'configuracion-academica/gestion-labs-configuracion'
	},
	GESTION_LABS_EQUIVALENCIAS: <RouteModel>{
		name: 'Gestion Labs Equivalencias',
		routerLink: 'configuracion-academica/gestion-labs-equivalencias',
		path: 'configuracion-academica/gestion-labs-equivalencias'
	},
	GESTION_LABS_CALIFICACION: <RouteModel>{
		name: 'Gestion Labs Calificación',
		routerLink: 'configuracion-academica/gestion-labs-calificacion',
		path: 'configuracion-academica/gestion-labs-calificacion'
	},
	TIPO_MATRICULA_ESPECIAL: <RouteModel>{
		name: "Tipo Matricula Especial",
		routerLink: "/main/administrative/matricula-especial",
		path: "/main/administrative/matricula-especial",
	},
	GESTION_CONCEPTO_PAGO: <RouteModel>{
		name: "Gestion Concepto Pago",
		routerLink: "/main/administrative/gestion-concepto-pago",
		path: "/main/administrative/gestion-concepto-pago",
	},
	GESTION_PLANTILLAS: <RouteModel>{
		name: "Gestión Plantillas",
		routerLink: "/main/configuraciones/configuracion-firma-electronica/gestion-plantillas",
		path: "/main/configuraciones/configuracion-firma-electronica/gestion-plantillas",
	},
	GESTION_FIRMANTES: <RouteModel>{
		name: "Gestión Firmantes",
		routerLink: "/main/configuraciones/configuracion-firma-electronica/gestion-firmantes",
		path: "/main/configuraciones/configuracion-firma-electronica/gestion-firmantes",
	},
	GESTION_VALIDACION: <RouteModel>{
		name: 'Gestion Validación',
		routerLink: 'configuracion-academica/gestion-validacion',
		path: 'configuracion-academica/gestion-validacion'
	},
	TIPO_DESCUENTO_MATRICULA_ESPECIAL: <RouteModel>{
		name: 'Gestion Configuración Matrícula Especial',
		routerLink:
			"/main/configuraciones/configuracion-matricula-linea/gestion-tipo-descuento/tipo-descuento-matricula-especial",
		path: "/main/configuraciones/configuracion-matricula-linea/gestion-tipo-descuento/tipo-descuento-matricula-especial",
	},
	GESTION_JAMESTOWN_TV: <RouteModel>{
		name: 'Gestion Jamestown Tv',
		routerLink:	"/main/configuraciones/configuracion-marketing/contenido-jamestown-tv",
		path: "/main/configuraciones/configuracion-marketing/contenido-jamestown-tv",
	},
 CONFIGURACION_SUBMENU: <RouteModel>{
		name: "Configuración Submenú",
		routerLink: "/main/security/configuracion-menu/configuracion-submenu/",
		path: "main/security/configuracion-menu/configuracion-submenu/",
	},
CONFIGURACION_MENU: <RouteModel>{
		name: "Configuración Menú",
		routerLink: "/main/security/configuracion-menu/",
		path: "main/security/configuracion-menu/",
	},

  GESTION_CONTENIDO_AUDIOVISUAL_LOGGIN: <RouteModel>{
		name: 'Gestion Contenido Audiovisual Loggin',
		routerLink: "/main/configuraciones/configuracion-marketing/contenido-audiovisual",
		path: "/main/configuraciones/configuracion-marketing/contenido-audiovisual",
	},
	GESTION_MOTIVO_RECHAZO_GHS: <RouteModel>{
		name: 'Gestión Motivo Rechazo GHS',
		routerLink: 'configuracion-academica/gestion-motivo-rechazo-ghs',
		path: 'configuracion-academica/gestion-motivo-rechazo-ghs'
	},
  TICKET_MANAGEMENT: <RouteModel>{
		name: 'Gestión de Tickets',
		routerLink: '/main/ticket-management',
		path: '/main/ticket-management'
	},
  ARCHIVED_TICKETS: <RouteModel>{
		name: 'Tickets Archivados',
		routerLink: '/main/ticket-management/archived-tickets',
		path: '/main/ticket-management/archived-tickets'
	},
	CAPSULAS_INFORMATIVAS: <RouteModel>{
		name: "Capsulas Informativas",
		routerLink: "/main/capsulas-informativas/",
		path: "/main/capsulas-informativas",
	},
	GESTION_CAPSULAS_INFORMATIVAS: <RouteModel>{
		name: 'Gestion Capsulas Informativas',
		routerLink: 'configuracion-academica/gestion-capsulas-informativas',
		path: 'configuracion-academica/gestion-capsulas-informativas'
	},
	GESTION_PLAN: <RouteModel>{
		name: 'Gestión Planes',
		routerLink: "/main/configuraciones/configuracion-suscripcion/gestion-plan",
		path: "/main/configuraciones/configuracion-suscripcion/gestion-plan",
	},
	GESTION_CARACTERISTICAS: <RouteModel>{
		name: 'Gestión Características',
		routerLink: "/main/configuraciones/configuracion-suscripcion/gestion-caracteristicas",
		path: "/main/configuraciones/configuracion-suscripcion/gestion-caracteristicas",
	}
};
